import { render, staticRenderFns } from "./my-driver-card-data-analysis.vue?vue&type=template&id=5f2d155d&scoped=true"
import script from "./my-driver-card-data-analysis.vue?vue&type=script&lang=js"
export * from "./my-driver-card-data-analysis.vue?vue&type=script&lang=js"
import style0 from "./my-driver-card-data-analysis.vue?vue&type=style&index=0&id=5f2d155d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2d155d",
  null
  
)

export default component.exports